import React from "react"
import cx from "classnames"
import styles from "./styles.module.scss"
import {
  FaAngleLeft,
  FaAngleRight,
  FaAngleDoubleRight,
  FaAngleDoubleLeft
} from "react-icons/fa"
import {Link} from "gatsby"

interface Props {
  nextPagePath: string
  previousPagePath: string
  humanPageNumber: number
  numberOfPages: number
  pageNumber: number
  basePath: string
}

const Pagination: React.FC<Props> = ({
  nextPagePath,
  previousPagePath,
  humanPageNumber,
  numberOfPages,
  pageNumber,
  basePath
}) => {
  return (
    <div className={cx(styles.Pagination)}>
      {humanPageNumber > 1 ? (
        <Link to={`${basePath}`}>
          <FaAngleDoubleLeft />{" "}
        </Link>
      ) : null}
      {previousPagePath !== "" ? (
        <Link to={previousPagePath}>
          <FaAngleLeft /> Previous{" "}
        </Link>
      ) : null}
      <p>
        Page {humanPageNumber} of {numberOfPages}
      </p>
      {nextPagePath !== "" ? (
        <Link to={nextPagePath}>
          Next <FaAngleRight />
        </Link>
      ) : null}
      {humanPageNumber < numberOfPages ? (
        <Link to={`${basePath}/${numberOfPages}`}>
          <FaAngleDoubleRight />{" "}
        </Link>
      ) : null}
    </div>
  )
}

export default Pagination
